import type { ICompanyApplicationTenant } from "@models";
import { getSolutionsAppMapId } from "@shared";
import { FIRST_PAGE_SOLUTIONS } from "./homeSolutionPagination.utils";

export {
  FIRST_PAGE_SOLUTIONS,
  getApplicationSolutionsPageCount,
  getApplicationSolutionsPageSlice,
  SUBSEQUENT_PAGE_SOLUTIONS,
} from "./homeSolutionPagination.utils";

const HOME_LAUNCHPAD_SECTION_SKELETON_COUNT = 4;

/** Stable keys for accordion-row loading placeholders. */
export const HOME_LAUNCHPAD_SECTION_SKELETON_KEYS = Array.from(
  { length: HOME_LAUNCHPAD_SECTION_SKELETON_COUNT },
  (_, index) => `home-launchpad-section-skeleton-${index}`,
);

/** Stable keys for first-page solution-card loading skeletons. */
export const HOME_SOLUTION_SKELETON_KEYS = Array.from(
  { length: FIRST_PAGE_SOLUTIONS },
  (_, index) => `home-solution-skeleton-${index}`,
);

/** Accordion value for the recently-used row (mock + live). */
export const RECENTLY_USED_SECTION_KEY = "recently-used";

/** Responsive solution card grid used by the home launchpad sections. */
export const HOME_SOLUTIONS_GRID_CLASS =
  "grid w-full grid-cols-[repeat(auto-fill,minmax(min(100%,20rem),1fr))] gap-4 [&>*]:min-w-0 [&>*]:w-full";

/** Accordion item / count-report key — must match between parent and sections. */
export function getHomeLaunchpadAppKey(
  appTenant: ICompanyApplicationTenant,
): string {
  return (
    getSolutionsAppMapId(appTenant) ||
    appTenant.appMapId ||
    appTenant.applicationId
  );
}
